import { render, staticRenderFns } from "./AuditSidebar.vue?vue&type=template&id=b048d68e&scoped=true&"
import script from "./AuditSidebar.vue?vue&type=script&lang=js&"
export * from "./AuditSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b048d68e",
  null
  
)

export default component.exports